import { useState } from 'react';

export function useMultiUploadProgress(initNumFiles = 0) {
  const [numFiles, setNumFiles] = useState(initNumFiles);
  const [uploadedFiles, setUploadedFiles] = useState(0);
  const [chunkSize, setChunkSize] = useState(0);
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);
  // 0 / 16 + 50 / 100 * 8 / 16
  const progress =
    numFiles > 0
      ? (uploadedFiles / numFiles +
          (uploadProgress ?? 0) * (chunkSize / numFiles)) *
        100
      : null;

  const reset = () => {
    setNumFiles(0);
    setUploadProgress(0);
    setUploadedFiles(0);
  };

  return {
    progress,
    setNumFiles,
    setChunkSize,
    setUploadedFiles,
    setUploadProgress,
    reset,
  };
}
